import axios from "axios";
import React, { useEffect, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { Link, useNavigate } from "react-router-dom";
import "./AllSchoolNotes.css";

const AllSchoolNotes = () => {
  const [boards, setBoards] = useState([]);
  const [boardId, setBoardId] = useState("");

  const [schoolClassName, setSchoolClassName] = useState([]);
  const [schoolClassNameId, setSchoolClassNameId] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [subjectId, setSubjectId] = useState("");

  const [language, setLanguage] = useState("");
  const [video, setVideo] = useState(false);
  const [schoolNotes, setSchoolNotes] = useState([]);

  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  /* =======================
     FETCH BOARDS
  ======================= */
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/boards`)
      .then((res) => setBoards(res.data.data))
      .catch(console.log);
  }, []);

  /* =======================
     FETCH CLASSES
  ======================= */
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/classes`)
      .then((resp) => setSchoolClassName(resp.data.data))
      .catch(console.log);
  }, []);

  /* =======================
     FETCH SUBJECTS
  ======================= */
  useEffect(() => {
    if (schoolClassNameId) {
      axios
        .get(`${API_BASE_URL}/subjects/?reference=${schoolClassNameId}`)
        .then((res) => setSubjects(res.data.data))
        .catch(console.log);
    }
  }, [schoolClassNameId]);

  /* =======================
     SEARCH NOTES
  ======================= */
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!boardId || !subjectId || !language) {
      alert("Please select Board, Subject and Language");
      return;
    }

    axios
      .get(
        `${API_BASE_URL}/notes?boardId=${boardId}&schoolSubjectId=${subjectId}&language=${language}&video=${video}`
      )
      .then((res) => setSchoolNotes(res.data.data))
      .catch(console.log);
  };

  /* =======================
     ACTIONS
  ======================= */
  const handleAddNewNote = () =>
    navigate("/upload-notes/upload-school-notes");

  const handleGoBack = () =>
    navigate("/upload-notes/upload-all-notes");

  const handleEdit = (id) =>
    navigate(`/upload-notes/edit-school-notes/${id}`);

  const handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this note?")) return;

    axios
      .delete(`${API_BASE_URL}/admin/notes/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then(() => {
        setSchoolNotes((prev) => prev.filter((n) => n._id !== id));
        alert("Note deleted successfully");
      })
      .catch(() => alert("Failed to delete note"));
  };

  return (
    <div id="allschoolnotes-inner-wrapper">
      <BiArrowBack
        onClick={handleGoBack}
        className="left-arrow-icon mt-3"
        style={{ cursor: "pointer", fontSize: "25px" }}
      />

      <div className="allschoolnotes-header-div">
        <h5>All School Notes</h5>
        <button className="add-note-btn" onClick={handleAddNewNote}>
          + Upload Notes
        </button>
      </div>

      <form onSubmit={handleSubmit} className="form-container">

        {/* BOARD */}
        <div className="input-group">
          <label className="label">Board</label>
          <select value={boardId} onChange={(e) => setBoardId(e.target.value)} required>
            <option value="">- Select Board -</option>
            {boards.map((b) => (
              <option key={b._id} value={b._id}>
                {b.boardName}
              </option>
            ))}
          </select>
        </div>

        {/* CLASS */}
        <div className="input-group">
          <label className="label">Class</label>
          <select
            value={schoolClassNameId}
            onChange={(e) => setSchoolClassNameId(e.target.value)}
            required
          >
            <option value="">- Select Class -</option>
            {schoolClassName.map((c) => (
              <option key={c._id} value={c._id}>
                {c.className}
              </option>
            ))}
          </select>
        </div>

        {/* SUBJECT */}
        <div className="input-group">
          <label className="label">Subject</label>
          <select value={subjectId} onChange={(e) => setSubjectId(e.target.value)} required>
            <option value="">- Select Subject -</option>
            {subjects.map((s) => (
              <option key={s._id} value={s._id}>
                {s.subjectName}
              </option>
            ))}
          </select>
        </div>

        {/* LANGUAGE */}
        <div className="input-group">
          <label className="label">Language</label>
          <select value={language} onChange={(e) => setLanguage(e.target.value)} required>
            <option value="">- Select Language -</option>
            <option value="hindi">Hindi</option>
            <option value="english">English</option>
          </select>
        </div>

        <div className="input-group">
          <label className="label">Video Filter  </label>
          <select value={video} onChange={(e) => setVideo(e.target.value)} required>
            {/* <option value="">- Videos -</option> */}
            <option value="false">All</option>
            <option value="true">Videos only</option>
          </select>
        </div>

        <button className="btn-save">Search Notes</button>
      </form>

      {/* TABLE */}
      <div className="allschoolnotes-table-container">
        <table className="allschoolnotes-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Title</th>
              <th>File</th>
              <th>Language</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {schoolNotes.map((note, i) => (
              <tr key={note._id}>
                <td>{i + 1}</td>
                <td>{note.noteTitle}</td>
                <td>
                  <Link
                    to={`${API_BASE_URL}/uploads/${note.noteFile}`}
                    target="_blank"
                  >
                    View
                  </Link>
                </td>
                <td>{note.language}</td>
                <td>
                  <i
                    className="fa-solid fa-file-pen"
                    onClick={() => handleEdit(note._id)}
                  ></i>
                  &nbsp;&nbsp;
                  <i
                    className="fa-solid fa-trash-can"
                    onClick={() => handleDelete(note._id)}
                  ></i>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllSchoolNotes;
